(function () {
    'use strict';

    let module = angular.module('imApp');

    module.component('crmMenu', {
        templateUrl: 'views/components/views/crmMenu/crmMenu.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['stateService', function (stateService) {
            const vm = this;

            vm.model = {
                name: stateService.getCurrentName()
            };
        }]
    });
})();
